import axios from "axios/index";
import config from "@/config/index"
import {CalcSign, ResponseCode} from "../apilist/util"
import _ from "lodash"

let addRequestProcess = (instance)=>{
	// add sign
	instance.interceptors.request.use(config=>{
		if(config.method !== "get"){
			let post_data = config.data;
			let post_params = config.params;

			// sign
			let {sign, timestamp} = CalcSign(post_data, post_params);
			if(config.params === undefined){
				config.params = {};
			}
			config.params['timestamp'] = timestamp;
			config.params['sign'] = sign;
		}
		return config;
	});

	// start progress
	instance.interceptors.request.use(config=>{
		NProgress.done().start();
		return config;
	}, error=>{
		NProgress.done();
		return Promise.reject(error);
	});

	// end progress
	instance.interceptors.response.use(response=>{
		NProgress.done();
		return response;
	}, error=>{
		NProgress.done();
		return Promise.reject(error);
	})
};

async function main_public_fetch(options){
	return new Promise((resolve, reject)=>{
		// Create axios object
		let access_token = $vue.$store.getters.access_token;

		let axios_config = {
			baseURL: config.api_base_host + config.version,
		};
		if(access_token !== null){
			axios_config['headers'] = {
				'Authorization': 'bearer ' + access_token,
			};
		}

		const instance = axios.create(axios_config);
		addRequestProcess(instance);

		// Request axios object
		return instance(options)
			.then((response)=>{
				let data = response.data;
				resolve(data);
			})
			.catch(error=>{
				ResponseCode(error);
				reject(error.response);
			})
	});
}

async function main_private_fetch(options){
	return new Promise((resolve, reject)=>{
		// Create axios object
		let axios_config = {
			baseURL: config.api_base_host + config.version,
		};

		let access_token = $vue.$store.getters.access_token;
		if(access_token === null){
			$vue.$router.push({name: "Login"});
			return;
		}

		// format access_token
		axios_config['headers'] = {
			'Authorization': 'bearer ' + access_token,
		};


		const instance = axios.create(axios_config);
		addRequestProcess(instance);


		// Request axios object
		return instance(options)
			.then((response)=>{
				let data = response.data;
				resolve(data)
			})
			.catch((error)=>{
				ResponseCode(error);
				reject(error.response);
			})
	})
}

async function node_public_fetch(options){
	return new Promise((resolve, reject)=>{
		// Create axios object
		let axios_config = {
			baseURL: config.node_base_host,
		};
		axios_config['headers'] = {}

		const instance = axios.create(axios_config);
		addRequestProcess(instance);

		// Request axios object
		return instance(options)
			.then((response)=>{
				let data = response.data;
				resolve(data)
			}).catch(error=>{
				if(!error.response){
					$vue.$Notice.error({
						title: '请求失败',
						desc: '网络连接失败，请稍后再试',
					})
				}else{
					reject(error);
				}
			})
	}).catch((error)=>{
	})
}


export {
	main_public_fetch,
	main_private_fetch,
	node_public_fetch,
};
